import { IVideoInfo } from 'mggp-player';
import { ContentType } from './types';

const tsReg = /\/ts\/\d+/;

export class PlayingEntity {
  public static addTimeOffsetInURL(offset: number, url: string): string {
    let idxSlash: number;
    const idxReg = url.search(tsReg);
    if (idxReg == -1) {
      idxSlash = url.lastIndexOf('/type.live');
      if (idxSlash === -1) {
        idxSlash = url.lastIndexOf('/playlist.');
      }
      url =
        url.substring(0, idxSlash) +
        '/ts/' +
        offset.toString() +
        url.substring(idxSlash);
    } else {
      url = url.replace(tsReg, '/ts/' + offset.toString());
    }
    return url;
  }

  public static removeTimeOffsetFromUrl(url: string): string {
    return url.replace(tsReg, '');
  }

  private _videoInfo: IVideoInfo;
  private _src: string;
  private _timeOffset = 0;
  private _startSeconds: number;
  private _isForceAutoplay: boolean;
  private _isVideoElementSeek = false;
  private _isMPD = false;

  constructor(
    videoInfo: IVideoInfo,
    options?: {
      startSeconds?: number;
      isForceAutoplay?: boolean;
    }
  ) {
    this._videoInfo = { ...videoInfo };
    this._src = videoInfo.src;
    this._startSeconds = options?.startSeconds ?? 0;
    this._isForceAutoplay = options?.isForceAutoplay ?? false;
    this._isMPD = this._src.indexOf('.mpd') !== -1;
  }

  get videoInfo(): IVideoInfo {
    return this._videoInfo;
  }
  get src(): string {
    return this._src;
  }
  get timeOffset(): number {
    return this._timeOffset;
  }
  get startSeconds(): number {
    return this._startSeconds;
  }
  get isForceAutoplay(): boolean {
    return this._isForceAutoplay;
  }
  get isCatchup(): boolean {
    const { content_type } = this._videoInfo;
    return (
      content_type === ContentType.tv_dvr_catchup ||
      content_type === ContentType.tv_dvr_vod
    );
  }
  get contentType(): ContentType {
    return this._videoInfo.content_type;
  }
  get isTimeshiftUrl(): boolean {
    let result: boolean;
    if (this._isMPD) {
      result = this._timeOffset !== 0;
    } else {
      result = this._src.includes('/ts/');
    }
    return result;
  }
  get isLiveSrc(): boolean {
    return this._videoInfo.content_type === ContentType.tv_dvr;
  }
  get isMPD(): boolean {
    return this._isMPD;
  }
  get isVideoElementSeek(): boolean {
    return this._isVideoElementSeek;
  }

  setTimeOffset = (timeOffset: number): void => {
    this._timeOffset = timeOffset;
    if (this._isMPD) {
      this._isVideoElementSeek = true;
    } else {
      if (timeOffset !== 0) {
        this._src = PlayingEntity.addTimeOffsetInURL(
          Math.round(timeOffset),
          this._src
        );
      } else {
        this._src = PlayingEntity.removeTimeOffsetFromUrl(this._src);
      }
    }
  };

  resetIsVideoElementSeek = (): void => {
    this._isVideoElementSeek = false;
  };

  setStartSeconds = (value: number, mpdTimeOffset?: number): void => {
    this._startSeconds = value;
    if (mpdTimeOffset !== undefined && this._isMPD) {
      this._timeOffset = mpdTimeOffset;
    }
  };

  resetForceAutoplay = (): void => {
    this._isForceAutoplay = false;
  }
}
